import { render, staticRenderFns } from "./quesBankform.vue?vue&type=template&id=2c0d6106&scoped=true&"
import script from "./quesBankform.vue?vue&type=script&lang=js&"
export * from "./quesBankform.vue?vue&type=script&lang=js&"
import style0 from "./quesBankform.vue?vue&type=style&index=0&id=2c0d6106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d6106",
  null
  
)

export default component.exports